import { NavLink as RouterNavLink, useLocation } from 'react-router-dom'
import { Text, Box } from '@chakra-ui/react'

export const NavItem = ({ to, children }: { to: string; children: React.ReactNode }) => {
  const location = useLocation()
  const isActive = location.pathname === to

  return (
    <Box
      as={RouterNavLink}
      to={to}
      w="100%"
      p={3}
      borderRadius="md"
      bg={isActive ? 'rgba(255, 133, 51, 0.2)' : 'transparent'}
      color={isActive ? 'synthwave.300' : 'synthwave.200'}
      transition="all 0.2s ease-in-out"
      textDecoration="none"
      display="block"
      _hover={{
        bg: 'rgba(255, 133, 51, 0.1)',
        color: 'synthwave.100'
      }}
    >
      <Text fontSize="md">{children}</Text>
    </Box>
  )
}

export default NavItem
